function getUserPropertiesFromLocalStorage() {
  const jsonString = localStorage.getItem('userProperties');
  return jsonString ? JSON.parse(jsonString) : {};
}

function setUserPropertiesToLocalStorage(userProperties) {
  localStorage.setItem('userProperties', JSON.stringify(userProperties));
}

/*
 * Stores user properties to local storage (only if browser support).
 * This will eventually be stored in server side
 */
export function getUserProperties(userId) {
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const userProperties = getUserPropertiesFromLocalStorage();
  return userProperties[userId] || {};
}

export function setUserProperty(userId, key, value) {
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const userProperties = getUserPropertiesFromLocalStorage();
  if (!userProperties[userId]) {
    userProperties[userId] = {};
  }
  userProperties[userId][key] = value;
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  setUserPropertiesToLocalStorage(userProperties);
}

export const getSelectedOutlet = (state) => state.form.search.values.outletIds;

export const getSelectedFirstOutlet = (state) =>
  state.form.search.values.outletIds[0];

export const getFormSearchFilter = (state) => state.form.search.values;

export function resetUserProperties() {
  localStorage.removeItem('userProperties');
}
